<template>  
  <v-card :loading="getRetentionLeadsLoading" height="100%">
    <v-card-title class="d-flex justify-space-between align-center">
      Cancellation Fee
      <slot name="titleBtn"></slot>
    </v-card-title>
    
    <v-card-text>
      <v-row>
        <v-col>
          <div>
            <span class="mb-1 text-caption mr-1">Proforma Fee</span>
            <template v-if="getHasProformaInvoice">
              <v-icon small color="grey" @click="downloadProformaInvoice($route.params.id)" class="mr-1">cloud_download</v-icon>
            </template>
            <BaseInfoTooltip top>The cancellation fee the customer needs to pay</BaseInfoTooltip>
          </div>

          <p class="display-1 accent--text">{{ getSingleRetentionLead.proforma_fee | formatCurrency }}</p>
        </v-col>

        <v-col>
          <div>
            <span class="mb-1 text-caption mr-1">Ad Hoc Invoice</span>
            <template v-if="getHasAdhocInvoice">
              <v-icon small color="grey" @click="downloadAdhocInvoice(getSingleRetentionLead.adhoc_invoice_id)" class="mr-1">cloud_download</v-icon>
            </template>
            <BaseInfoTooltip top>The invoice generated quoting the proforma fee</BaseInfoTooltip>
          </div>

          <p class="display-1 accent--text">{{ getSingleRetentionLead.cancellation_fee | formatCurrency }}</p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  props: {
    account: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    ...mapGetters("retention", ["getSingleRetentionLead", "getRetentionLeadsLoading"]),
    ...mapGetters("retention/proformaInvoice", ["getIsDownloadProformaInvoiceDataLoading"]),
    ...mapGetters("retention/adhocInvoice", ["getIsDownloadAdhocInvoiceDataLoading"]),

    getHasAdhocInvoice() {
      const { adhoc_invoice_id, cancellation_fee } = this.getSingleRetentionLead;
      return adhoc_invoice_id && cancellation_fee;
    },

    getHasProformaInvoice() {
      const { proforma_invoice_id, proforma_fee } = this.getSingleRetentionLead;
      return proforma_invoice_id && proforma_fee;
    }
  },

  methods: {
    ...mapActions("retention/adhocInvoice", ["downloadAdhocInvoice"]),
    ...mapActions("retention/proformaInvoice", ["downloadProformaInvoice"]),
  }
}
</script>

<style>

</style>